const BillingEnums = {
  // Agilite Profile Keys
  profileKeys: {
    FOLLOW_UP_ACCOUNTS: 'follow_up_accounts',
    COMPENSATION_CLAIMS: 'compensation_claims',
    PATIENT_LEDGER: 'patient_ledger',
    CLAIM_DOCUMENTS: 'claim_documents',
    FOLLOW_UP_HISTORY: 'follow_up_history',
    ACCOUNT_NOTES: 'account_notes',
    BILLING_SETTINGS: 'billing_settings',
    CREDIT_NOTES: 'credit_notes',
    PAYMENT_ALLOCATIONS: 'payment_allocations',
    UNALLOCATED_PAYMENTS: 'unallocated_payments',
    PAYMENT_PLANS: 'payment_plans',
    AUDIT_TRAIL: 'audit_trail',
    REFUNDS: 'refunds'
  },

  // Agilite Route Keys
  routeKeys: {
    CREATE: 'create',
    READ: 'read',
    UPDATE: 'update',
    DELETE: 'delete',
    FIND: 'find',
    FIND_BY_ID: 'find_by_id',
    FIND_ONE: 'find_one',
    COUNT: 'count',
    AGGREGATE: 'aggregate',
    INSERT_MANY: 'insert_many',
    UPDATE_MANY: 'updateMany',
    DELETE_MANY: 'delete_many'
  },

  // Follow-up Status
  followUpStatus: {
    AWAITING_PAYMENT_PATIENT: 'awaiting_payment_patient',
    AWAITING_PAYMENT_AID: 'awaiting_payment_aid',
    DISPUTED: 'disputed',
    IN_COLLECTION: 'in_collection',
    PARTIAL_PAYMENT: 'partial_payment',
    PAYMENT_PLAN: 'payment_plan',
    COMPLETED: 'completed',
    WRITTEN_OFF: 'written_off'
  },

  // Account Groups
  accountGroups: {
    PRIVATE: 'private',
    MEDICAL_AID: 'medical_aid',
    COID: 'coid',
    FEM: 'fem',
    SAPS: 'saps',
    RMA: 'rma'
  },

  // Aging Buckets
  agingBuckets: {
    CURRENT: '0-29',
    THIRTY: '30-59',
    SIXTY: '60-89',
    NINETY_PLUS: '90+'
  },

  // Claim Status
  claimStatus: {
    DRAFT: 'draft',
    SUBMITTED: 'submitted',
    UNDER_REVIEW: 'under_review',
    ADDITIONAL_INFO_REQUIRED: 'additional_info_required',
    APPROVED: 'approved',
    PARTIALLY_APPROVED: 'partially_approved',
    REJECTED: 'rejected',
    PAID: 'paid',
    CLOSED: 'closed'
  },

  // Credit Note Status
  creditNoteStatus: {
    DRAFT: 'draft',
    APPROVED: 'approved',
    APPLIED: 'applied',
    CANCELLED: 'cancelled'
  },

  // Transaction Types
  transactionTypes: {
    INVOICE: 'invoice',
    PAYMENT: 'payment',
    MEDICAL_AID_PAYMENT: 'medical_aid_payment',
    MEDICAL_AID_ALLOCATION: 'medical_aid_allocation',
    MEDICAL_AID_APPROVAL: 'medical_aid_approval',
    CREDIT: 'credit',
    DEBIT: 'debit',
    ADJUSTMENT: 'adjustment',
    REFUND: 'refund',
    WRITE_OFF: 'write_off',
    CREDIT_NOTE: 'credit_note',
    INTEREST: 'interest',
    FEE: 'fee',
    PAYMENT_REVERSAL: 'payment_reversal',
    TRANSFER: 'transfer'
  },

  // Medical Aid Claim Status
  medicalAidClaimStatus: {
    SUBMITTED: 'submitted',
    ACKNOWLEDGED: 'mfACK',
    APPROVED: 'mfAPP',
    PAID: 'PAID',
    REJECTED: 'mfREJ',
    SWITCH_REJECTED: 'swREJ',
    SWITCH_ACKNOWLEDGED: 'swACC',
    PROCESSING: 'processing',
    PENDING: 'pending'
  },

  // Communication Types
  communicationTypes: {
    EMAIL: 'email',
    SMS: 'sms',
    WHATSAPP: 'whatsapp',
    PHONE_CALL: 'phone_call',
    LETTER: 'letter',
    IN_PERSON: 'in_person'
  },

  // Payment Methods
  paymentMethods: {
    CASH: 'cash',
    CARD: 'card',
    EFT: 'eft',
    MEDICAL_AID: 'medical_aid',
    CHEQUE: 'cheque',
    ONLINE: 'online'
  },

  // Error Messages
  errorMessages: {
    ACCOUNT_NOT_FOUND: 'Follow-up account not found',
    CLAIM_NOT_FOUND: 'Compensation claim not found',
    INVALID_STATUS: 'Invalid status transition',
    MISSING_REQUIRED_FIELDS: 'Missing required fields',
    UNAUTHORIZED: 'Unauthorized access',
    DUPLICATE_ACCOUNT: 'Duplicate account exists',
    INVALID_AMOUNT: 'Invalid amount specified'
  }
}

export default BillingEnums

// Export transaction types separately for convenience
export const TRANSACTION_TYPES = BillingEnums.transactionTypes

// Also export as named export
export { BillingEnums }
